var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home bg_image"},[_vm._m(0),_c('Login')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 col-md-4 col-lg-4 pt-5"}),_c('div',{staticClass:"col-sm-4 col-md-4 col-lg-4 pt-5"},[_c('img',{staticClass:"login_logo",attrs:{"src":require("@/assets/img/atl_new_logo.png")}})]),_c('div',{staticClass:"col-sm-4 col-md-4 col-lg-4"})])
}]

export { render, staticRenderFns }